import PropTypes from "prop-types"
import React, { useCallback } from "react"

import { Button } from "../atoms/Buttons"
import { P } from "../atoms/Elements"
import { WithModal } from "../Modal"
import { SigninModalContent } from "../SigninModal.tsx"

export const AddToKarbonSignInModal = props => {
  const toggle = useCallback(
    show => (
      <Button className={"addButton"} onClick={() => show()}>
        Add to Karbon
      </Button>
    ),
    []
  )

  const modalContent = useCallback(() => {
    return (
      <SigninModalContent
        slug={props.slug}
        loginTitle="Login to Karbon"
        loginText={
          <P>
            You don&apos;t seem to be logged in. You&apos;ll need to login to
            Karbon before adding a template.
          </P>
        }
        trialText={<P>You’ll have access to 50 preloaded templates.</P>}
      />
    )
  }, [props.slug])

  return (
    <WithModal
      toggle={props.toggle || toggle}
      ChildContent={modalContent}
      startOpen={props.startOpen}
    />
  )
}

AddToKarbonSignInModal.propTypes = {
  slug: PropTypes.string.isRequired,
  startOpen: PropTypes.bool, // pop modal open when it mounts
  toggle: PropTypes.func, // Optional custom toggle function, see default one above for signature
}
